export const DEFAULT_STORE = 'DEFAULT_STORE';
export const DEFAULT_WHITELABEL = 'DEFAULT_WHITELABEL';
export const LIST_WHITELABEL = 'LIST_WHITELABEL';
